import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchMode } from '@digilize/shared/definitions/src';
import { SharedAccountDataService } from '@bwc/src/app/services/shared-account-data.service';
import { map } from 'rxjs';

import { Vacancy } from '../../models/vacancy.model';
import { matchColor } from '../../utils/match-color';

@Component({
  selector: 'bwc-vacancy-card',
  templateUrl: './vacancy-card.component.html',
  styleUrls: ['./vacancy-card.component.scss'],
})
export class VacancyCardComponent {
  @Input() vacancy: Vacancy;
  @Input() isLiked = false;
  @Input() searchMode?: SearchMode;
  @Input() hideMatchBar = false;
  @Output() liked = new EventEmitter<Vacancy>();
  @Output() cardClick = new EventEmitter<Vacancy>();
  isActivated$ = this.sharedAccountDataService.cv$.pipe(map((cv) => !!cv?.activated));

  matchColor = matchColor;

  get isSurpriseMe(): boolean {
    return this.searchMode === SearchMode.SurpriseMe;
  }

  constructor(private sharedAccountDataService: SharedAccountDataService) {}

  onCardClick(): void {
    this.cardClick.emit(this.vacancy);
  }

  onLike(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.liked.emit(this.vacancy);
  }
}
